import { Injectable } from '@angular/core';
import { ColmecDiscount, ColmecDiscountsService } from './colmec-discounts.service';
import { ConfigBaseFilter, ConfigFilterGroup, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, PimTemplateProperties, SearchField, SelectionAction } from 'gung-list';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ColmecDiscountListViewComponent } from '../components/colmec-discounts/colmec-discount-list-view/colmec-discount-list-view.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecDiscountListConfigService implements ConfigService<ColmecDiscount> {

  constructor(
    protected colmecDiscounts: ColmecDiscountsService
  ) { }

  getItems(route?: ActivatedRouteSnapshot): Observable<ColmecDiscount[]> {
    return this.colmecDiscounts.getColmecDiscounts();
  }
  getFilters(route?: ActivatedRouteSnapshot): ConfigBaseFilter<ColmecDiscount>[] {
    return [];
  }
  getSortOptions(route?: ActivatedRouteSnapshot): ListSortOption<ColmecDiscount>[] {
    return []
  }
  getBatchSizes(route?: ActivatedRouteSnapshot): number[] {
    return [48];
  }
  getLayouts(route?: ActivatedRouteSnapshot): ListLayout<ColmecDiscount>[] {
   
      return [
        {
          getIconClass: () => 'fas fa-th-list',
          getListItemComponent: () => ColmecDiscountListViewComponent,
          getListLayoutComponent: () => ListLayoutMultipleComponent,
          getName: () => 'ProductList'
        }
      ];
    
  }

  getSearchTerms(item: ColmecDiscount): string[] {
    return [item.agreementId, item.supplierName];
  }
  getItemId(item: ColmecDiscount): string {
    return item.agreementId;
  }
  
}
